/* Promo Slider - CPAP Direct homepage promotions */
(function () {
  function init(root) {
    if (!root || root.dataset.psInit) return;
    root.dataset.psInit = '1';
    var track = root.querySelector('.ps-track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ps-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ps-dot'));
    var pauseBtn = root.querySelector('.ps-pause');
    var count = slides.length;
    if (!track || count < 2) return;

    var current = 0, timer = null, hover = false, userPaused = false, lock = false, lockT = null, st = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 7000;
    if (reduce) userPaused = true;

    function width() { return track.clientWidth || 1; }
    function mark() {
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === current ? 'true' : 'false'); });
    }
    function go(i, instant) {
      current = (i + count) % count;
      lock = true;
      clearTimeout(lockT);
      lockT = setTimeout(function () { lock = false; }, 1200);
      track.scrollTo({ left: current * width(), behavior: (reduce || instant) ? 'auto' : 'smooth' });
      mark();
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (autoplay && !hover && !userPaused && !document.hidden) {
        timer = setInterval(function () { go(current + 1); }, speed);
      }
    }
    function syncPause() {
      if (!pauseBtn) return;
      pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
    }

    var prev = root.querySelector('.ps-arrow--prev');
    var next = root.querySelector('.ps-arrow--next');
    if (prev) prev.addEventListener('click', function () { go(current - 1); start(); });
    if (next) next.addEventListener('click', function () { go(current + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.go, 10)); start(); });
    });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { userPaused = !userPaused; syncPause(); start(); });

    /* Keep dots in sync when the visitor swipes/scrolls the track themselves */
    function settle() {
      var i = Math.round(track.scrollLeft / width());
      if (i >= 0 && i < count && i !== current) { current = i; mark(); }
    }
    track.addEventListener('scroll', function () {
      if (lock) {
        if (Math.abs(track.scrollLeft - current * width()) < 2) { lock = false; }
        return;
      }
      clearTimeout(st);
      st = setTimeout(settle, 100);
    }, { passive: true });
    track.addEventListener('scrollend', function () { lock = false; settle(); });

    root.addEventListener('mouseenter', function () { hover = true; stop(); });
    root.addEventListener('mouseleave', function () { hover = false; start(); });
    track.addEventListener('focusin', function () { hover = true; stop(); });
    track.addEventListener('focusout', function () { hover = false; start(); });
    track.addEventListener('touchstart', function () { lock = false; stop(); }, { passive: true });
    track.addEventListener('touchend', start, { passive: true });
    document.addEventListener('visibilitychange', start);
    window.addEventListener('resize', function () { track.scrollTo({ left: current * width(), behavior: 'auto' }); });

    /* Theme editor: jump to the slide being edited */
    document.addEventListener('shopify:block:select', function (e) {
      var s = document.getElementById('PromoSlide-' + e.detail.blockId);
      if (s && root.contains(s)) { hover = true; stop(); go(slides.indexOf(s), true); }
    });
    document.addEventListener('shopify:block:deselect', function () { hover = false; start(); });

    syncPause();
    mark();
    start();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.promo-slider'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
